export default __webpack_public_path__ + "static/media/IDK_You_Pick.6b70df38.png";